import { Pipe, PipeTransform } from '@angular/core'
import { DatePipe } from '@angular/common'
import { Observable, of } from 'rxjs'

@Pipe({
    name: 'formatDateWithTimezone',
    pure: true,
    standalone: false
})
export class FormatDateWithTimezonePipe implements PipeTransform {

    constructor(private readonly datePipe: DatePipe) { }

    transform(value: Date | number | string | undefined | null, format: string = 'dd/MM/yyyy HH:mm'): Observable<string | null> {
        if (!value) return of()
        const localDate = this.convertToLocalTimezone(new Date(value))
        const formattedDate = this.datePipe.transform(localDate, format)
        return formattedDate ? of(formattedDate) : of()
    }

    private convertToLocalTimezone(date: Date): Date {
        const localTimezoneOffset = date.getTimezoneOffset() * 60000
        return new Date(date.getTime() - localTimezoneOffset)
    }
}
